import script from "./options.vue?vue&type=script&setup=true&lang=ts"
export * from "./options.vue?vue&type=script&setup=true&lang=ts"

import "./options.vue?vue&type=style&index=0&id=0ab210ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ab210ba"]])

export default __exports__